//libs\core\http\src\lib\interceptors\auth-bearer.interceptor.class.ts
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TenantAuthService } from '@cardapio-online/auth';
import { Observable, catchError, throwError } from 'rxjs';
import { SKIP_ADMIN_AUTH } from '../contexts/skip-admin-auth.context';

@Injectable()
export class AuthBearerInterceptor implements HttpInterceptor {
  private readonly publicPaths = ['/auth/login'];

  constructor(
    private readonly auth: TenantAuthService,
    private readonly router: Router
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isPublic = this.publicPaths.some((path) => req.url.includes(path));
    const skipAdminAuth = req.context.get(SKIP_ADMIN_AUTH);
    const hasExplicitAuthorization = req.headers.has('Authorization');
    const token = this.auth.getToken();

    const authorizedReq =
      !isPublic && !skipAdminAuth && !hasExplicitAuthorization && token
        ? req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          })
        : req;

    return next.handle(authorizedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 401 &&
          !isPublic &&
          !skipAdminAuth &&
          !hasExplicitAuthorization &&
          !!token
        ) {
          this.auth.logout();
          void this.router.navigateByUrl('/login');
        }

        return throwError(() => error);
      })
    );
  }
}
